import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker"
import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
    addVisitors,
 } from 'Actions';

class AddItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {

	}
    constructor(props) {
      
        super(props);
        this.state = {
           
            checkoutdate:'',
            checkindate:'',
            ssstartdate:'',
            ssenddate:''
            
        };
    }

    selectdate = (date, val) => {      
        
        if(val==1){
            this.setState({ checkindate:date });
        }else if(val==2){
            this.setState({ checkoutdate:date });
        }else if(val==3){
            this.setState({ ssstartdate:date });
        }else if(val==4){
            this.setState({ ssenddate:date });
        }
        
        
   }

       

    addHandleSubmit(event){
        event.preventDefault();
        this.props.addVisitors(event).then((data) => {   
        
            if(data.status==1){                    
                document.getElementById("addform").reset(); 
                this.setState({ 
                    checkoutdate:'',
                    checkindate:'',
                    ssstartdate:'',
                    ssenddate:''
                });                  
            }
        });
        
    }  


render() {

     
      return(
        <div>
             <div className="col-lg-12">
                <form autoComplete="off" id="addform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-lg-8">
                            <RctCollapsibleCard heading="Create visitor">   
                                    <div className="row">                                 
                                       
                                        <div className="col-sm-12 col-lg-6">
                                          <FormGroup>
                                             <Label for="Select">Name *</Label>
                                             <input type="text" name="name" id="name" className="form-control form-control-alternative" required />                                             
                                          </FormGroup>
                                       </div> 
                                       <div className="col-sm-12 col-lg-6">
                                          <FormGroup>
                                             <Label for="Select">Mobile</Label>
                                             <input type="text" name="mobile" id="mobile" className="form-control form-control-alternative" />
                                          </FormGroup>
                                       </div>
                                       <div className="col-sm-12 col-lg-6 col-xl-6">
                                            <FormGroup>
                                                <Label for="Email-3">Check-In Date *</Label>
                                                <DatePicker className="form-control" id="checkindate"  name="checkindate" autoComplete="off" required
                                                        selected={this.state.checkindate}
                                                        onChange={(date)=>this.selectdate(date,1)}
                                                        dateFormat='yyyy-MM-dd '
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        popperPlacement="bottom" 
                                                        popperModifiers={{ flip: { behavior: ["bottom"] }, preventOverflow: { enabled: false }, hide: { enabled: false } }} 
                                                    /> 
                                            </FormGroup>                                          
                                        </div>
                                        <div className="col-sm-12 col-lg-6 col-xl-6">
                                            <FormGroup>
                                                <Label for="Email-3">Check-Out Date *</Label>
                                                <DatePicker className="form-control" id="checkoutdate"  name="checkoutdate" autoComplete="off" required
                                                        selected={this.state.checkoutdate}
                                                        onChange={(date)=>this.selectdate(date,2)}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        popperPlacement="bottom" 
                                                        popperModifiers={{ flip: { behavior: ["bottom"] }, preventOverflow: { enabled: false }, hide: { enabled: false } }} 
                                                    /> 
                                            </FormGroup>                                          
                                        </div>
                                        <div className="col-sm-12 col-lg-6 col-xl-6">
                                            <FormGroup>
                                                <Label for="Email-3">Session Start Date *</Label>
                                                <DatePicker className="form-control" id="startdate"  name="startdate" autoComplete="off" required
                                                        selected={this.state.ssstartdate}
                                                        onChange={(date)=>this.selectdate(date,3)}
                                                        dateFormat='yyyy-MM-dd '
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        popperPlacement="bottom" 
                                                        popperModifiers={{ flip: { behavior: ["bottom"] }, preventOverflow: { enabled: false }, hide: { enabled: false } }} 
                                                    /> 
                                            </FormGroup>                                          
                                        </div>
                                        <div className="col-sm-12 col-lg-6 col-xl-6">
                                            <FormGroup>
                                                <Label for="Email-3">Session End Date *</Label>
                                                <DatePicker className="form-control" id="enddate"  name="enddate" autoComplete="off" required
                                                        selected={this.state.ssenddate}
                                                        onChange={(date)=>this.selectdate(date,4)}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        popperPlacement="bottom" 
                                                        popperModifiers={{ flip: { behavior: ["bottom"] }, preventOverflow: { enabled: false }, hide: { enabled: false } }} 
                                                    /> 
                                            </FormGroup>                                          
                                        </div>                                       
                                        <div className="col-lg-12">
                                            <div className="form-group"> 
                                                <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" /> 
                                                <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button>    
                                            </div>
                                        </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
                       </div>
                </div>
              
    )
   
}
 
}

const mapStateToProps = ({ visitors}) => {
    
   
}


export default connect(mapStateToProps, {
    
    addVisitors,
})(AddItems);
